import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { BaseModalComponent } from './components/base-modal/base-modal.component';
import { ReportCatismaYonetimComponent } from './report-components/report-catisma-yonetim/report-catisma-yonetim.component';
import { ReportClassCatismaYonetimComponent } from './report-components/report-class-catisma-yonetim/report-class-catisma-yonetim.component';
import { ReportClassDavranisTarziComponent } from './report-components/report-class-davranis-tarzi/report-class-davranis-tarzi.component';
import { ReportClassDurumsalLiderlikComponent } from './report-components/report-class-durumsal-liderlik/report-class-durumsal-liderlik.component';
import { ReportClassKisilerArasiEtkilesimComponent } from './report-components/report-class-kisiler-arasi-etkilesim/report-class-kisiler-arasi-etkilesim.component';
import { ReportClassLiderlikStiliComponent } from './report-components/report-class-liderlik-stili/report-class-liderlik-stili.component';
import { ReportClassMotivasyonComponent } from './report-components/report-class-motivasyon/report-class-motivasyon.component';
import { ReportClassNasilDinliyoruzComponent } from './report-components/report-class-nasil-dinliyoruz/report-class-nasil-dinliyoruz.component';
import { ReportClassSatisTarziComponent } from './report-components/report-class-satis-tarzi/report-class-satis-tarzi.component';
import { ReportClassYonetimYetenekleriComponent } from './report-components/report-class-yonetim-yetenekleri/report-class-yonetim-yetenekleri.component';
import { ReportDavranisTarziComponent } from './report-components/report-davranis-tarzi/report-davranis-tarzi.component';
import { ReportDelegasyonComponent } from './report-components/report-delegasyon/report-delegasyon.component';
import { ReportDurumsalLiderlikComponent } from './report-components/report-durumsal-liderlik/report-durumsal-liderlik.component';
import { ReportKisilerArasiEtkilesimComponent } from './report-components/report-kisiler-arasi-etkilesim/report-kisiler-arasi-etkilesim.component';
import { ReportLiderlikStiliComponent } from './report-components/report-liderlik-stili/report-liderlik-stili.component';
import { ReportMotivasyonComponent } from './report-components/report-motivasyon/report-motivasyon.component';
import { ReportNasilDinliyoruzComponent } from './report-components/report-nasil-dinliyoruz/report-nasil-dinliyoruz.component';
import { ReportSatisTarziComponent } from './report-components/report-satis-tarzi/report-satis-tarzi.component';
import { ReportYonetimYetenekleriComponent } from './report-components/report-yonetim-yetenekleri/report-yonetim-yetenekleri.component';
import { ReportClassDegerlendiriciKontrolComponent } from './report-vaka-components/report-class-degerlendirici-kontrol/report-class-degerlendirici-kontrol.component';
import { ReportClassMusteriDeneyimiComponent } from './report-vaka-components/report-class-musteri-deneyimi/report-class-musteri-deneyimi.component';
import { ReportMusteriDeneyimiComponent } from './report-vaka-components/report-musteri-deneyimi/report-musteri-deneyimi.component';
import { ReportSahaTakipComponent } from './report-vaka-components/report-saha-takip/report-saha-takip.component';
import { ReportTrainingMusteriDeneyimiComponent } from './report-vaka-components/report-training-musteri-deneyimi/report-training-musteri-deneyimi.component';
import { BootstrapModule } from './shared-bootstrap.module';
import { SharedModalModule } from './shared-modal.module';

@NgModule({
  declarations: [
    ReportYonetimYetenekleriComponent,
    ReportCatismaYonetimComponent,
    ReportDurumsalLiderlikComponent,
    ReportDavranisTarziComponent,
    ReportKisilerArasiEtkilesimComponent,
    ReportLiderlikStiliComponent,
    ReportMusteriDeneyimiComponent,
    ReportClassMusteriDeneyimiComponent,
    ReportTrainingMusteriDeneyimiComponent,
    ReportClassDegerlendiriciKontrolComponent,
    ReportClassDavranisTarziComponent,
    ReportClassKisilerArasiEtkilesimComponent,
    ReportClassDurumsalLiderlikComponent,
    ReportClassCatismaYonetimComponent,
    ReportClassLiderlikStiliComponent,
    ReportClassYonetimYetenekleriComponent,
    ReportSatisTarziComponent,
    ReportNasilDinliyoruzComponent,
    ReportDelegasyonComponent,
    ReportMotivasyonComponent,
    ReportClassSatisTarziComponent,
    ReportClassNasilDinliyoruzComponent,
    ReportClassMotivasyonComponent,
    ReportSahaTakipComponent
  ],
  imports: [
    CommonModule,
    FormsModule,
    RouterModule,
    BootstrapModule,
    SharedModalModule
  ],
  exports: [
    ReportYonetimYetenekleriComponent,
    ReportCatismaYonetimComponent,
    ReportDurumsalLiderlikComponent,
    ReportDavranisTarziComponent,
    ReportKisilerArasiEtkilesimComponent,
    ReportLiderlikStiliComponent,
    ReportMusteriDeneyimiComponent,
    ReportClassMusteriDeneyimiComponent,
    ReportTrainingMusteriDeneyimiComponent,
    ReportClassDegerlendiriciKontrolComponent,
    ReportClassDavranisTarziComponent,
    ReportClassKisilerArasiEtkilesimComponent,
    ReportClassDurumsalLiderlikComponent,
    ReportClassCatismaYonetimComponent,
    ReportClassLiderlikStiliComponent,
    ReportClassYonetimYetenekleriComponent,
    ReportSatisTarziComponent,
    ReportNasilDinliyoruzComponent,
    ReportDelegasyonComponent,
    ReportMotivasyonComponent,
    ReportClassSatisTarziComponent,
    ReportClassNasilDinliyoruzComponent,
    ReportClassMotivasyonComponent,
    ReportSahaTakipComponent
  ]
})
export class SharedReportModule { }
